module.exports = __webpack_public_path__ + "static/img/login.0bdcad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/login.jpg
// module id = Sem9
// module chunks = 2